export const environment = {
  production: true,
  stripeKey: "pk_live_jMzdyON0v3Lcl7Kh8x8IJels"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts